// src/components/InstantAIScoring.js

import React from 'react';
import { Zap, Star } from 'lucide-react';
import './css/InstantAIScoring.css';

const scores = [
  { label: 'Emotion Score', value: 85 },
  { label: 'Voice Clarity', value: 94 },
  { label: 'Confidence', value: 88 },
  { label: 'Role Fit', value: 91 },
];

const InstantAIScoring = () => {
  return (
    <section className="instant-ai-section">
      <div className="instant-ai-container">
        
        {/* --- LEFT COLUMN: TEXT & FEATURES --- */}
        <div className="instant-ai-left">
          <span className="instant-ai-tag">AI POWERED</span>

          <h2 className="instant-ai-title">Performance Scoring</h2>

          <p className="instant-ai-description">
            Our advanced AI analyzes your self-tape auditions in real-time. Get
            scores on emotion, clarity, and confidence before you even hit
            submit.
          </p>

          <div className="instant-ai-features">
            <div className="instant-ai-feature">
              <div className="instant-ai-feature-icon">
                <Zap size={20} />
              </div>
              <div className="instant-ai-feature-text">
                <h4>Real-time Feedback</h4>
                <p>Know exactly where you stand instantly.</p>
              </div>
            </div>

            <div className="instant-ai-feature">
              <div className="instant-ai-feature-icon">
                <Star size={20} />
              </div>
              <div className="instant-ai-feature-text">
                <h4>Skill Gap Analysis</h4>
                <p>Identify areas for improvement.</p>
              </div>
            </div>
          </div>
        </div>

        {/* --- RIGHT COLUMN: ANALYSIS CARD --- */}
        <div className="instant-ai-right">
          <div className="analysis-card">
            <div className="analysis-card-header">
              <h3>AI Analysis Report</h3>
              <span className="match-badge">92% Match</span>
            </div>

            <div className="analysis-score-list">
              {scores.map((score, index) => (
                <div className="analysis-score-item" key={index}>
                  <div className="analysis-score-top">
                    <span className="score-label">{score.label}</span>
                    <span className="score-value">{score.value}%</span>
                  </div>

                  <div className="progress-track">
                    <div
                      className="progress-fill"
                      style={{ width: `${score.value}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default InstantAIScoring;